<template>
	<div
		class="cart-cross-sell"
		v-if="cartCrossSell.length"
	>
		<h2
			v-if="isLoggedIn"
			class="cart-cross-sell__title"
			v-html="$t('cart.crossSell.titleLoggedIn', { name: this.accountUserDetail.firstName })"
		/>
		<h2
			v-else
			class="cart-cross-sell__title"
			v-html="$t('cart.crossSell.title')"
		/>
		<div class="cart-cross-sell__products">
			<!-- loop -->
			<ShoplistProduct
				v-for="(product, index) in productsEnhanced"
				:key="product.code"
				:product="product"
				:locked="lockedProducts[product.code]"
				@addToCart="onAddToCart"
				@config="onConfig"
				@click="onClickProduct"
			/>
			<!-- loop end -->
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import GenericMixin from '@/mixins/GenericVueMixin'
import ProductListMixin from '@/mixins/ProductListVueMixin'
import ShoplistProduct from '@/components/ShoplistProduct'
import Loader from '@/components/Loader';

export default {
	mixins: [
		GenericMixin,
		ProductListMixin,
	],
	components: {
		ShoplistProduct,
		Loader,
	},
	computed: {
		...mapGetters("account", [
			"isLoggedIn",
			"accountUserDetail",
			"accountGroupCodes",
		]),
		...mapGetters('cart', [
			'showContinue',
			'cartCrossSell'
		]),
		productsEnhanced() {
			return this.enhanceProducts(this.cartCrossSell);
		}
	},
	methods: {
		onClickProduct(code) {
			// console.log(this.getProduct(code));
		},
	}
}
</script>

<style>

</style>
